// Storage utility functions for authentication data
export const clearAuthData = (): void => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('id_token');
  localStorage.removeItem('user');
  localStorage.removeItem('auth_state');

  // Clear session storage as well
  sessionStorage.clear();

  console.log('✅ Logout cleanup completed');
};
